import { useIntl } from 'react-intl';

import { TargetingCard } from '../common/TargetingCard';

export type GenderCardId = 'all' | 'f' | 'm';

const GENDER_CARD_ICONS: Record<GenderCardId, string> = {
  all: 'fa-solid fa-mars-and-venus',
  f: 'fa-solid fa-venus',
  m: 'fa-solid fa-mars'
};

const GENDER_CARD_IDS: GenderCardId[] = ['all', 'f', 'm'];

type Props = {
  className?: string;
  onSelect: (gender: GenderCardId) => void;
  selected?: GenderCardId;
};

/** One gender (or all) selected with a card per option, shared by the digital and DOOH demography */
export function GenderCards({ className, onSelect, selected }: Props) {
  const { formatMessage } = useIntl();

  return (
    <div className={className}>
      {GENDER_CARD_IDS.map(id => (
        <TargetingCard
          icon={GENDER_CARD_ICONS[id]}
          isSelected={selected === id}
          key={id}
          label={formatMessage({
            defaultMessage: id,
            id: `targeting.demography.gender.options.${id}`
          })}
          onClick={() => onSelect(id)}
          subtitle={formatMessage({
            defaultMessage: 'Gender',
            id: 'targeting.demography.gender.subtitle'
          })}
        />
      ))}
    </div>
  );
}
